export default __webpack_public_path__ + "static/e-commerce-3d-display-board-f19e4db0616e6a99a58c967d88288a02.gif";